"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketEntryHistory = void 0;
const TicketEntryHistoryList_1 = require("./TicketEntryHistoryList");
class TicketEntryHistory {
    constructor(data) {
        this.enteredDateConverted = null;
        this.enteredTimeConverted = null;
        this.barcodeDisplayValue = null;
        this.isOnlineEntry = false;
        this.id = data.id;
        this.enteredTime = data.enteredTime;
        this.login = data.login;
        this.gameLogId = data.gameLogId;
        this.ticketId = data.ticketId;
        this.ticket = data.ticket;
        this.game = data.game;
        this.prizes = data.prizes;
    }
}
exports.TicketEntryHistory = TicketEntryHistory;
TicketEntryHistory.JsonToTickets = (data, withoutPattern) => {
    const ticketEntryHistoryList = new TicketEntryHistoryList_1.TicketEntryHistoryList();
    data.forEach(ticket => {
        if (!ticketEntryHistoryList.map(x => x.id).includes(ticket.id)) {
            ticketEntryHistoryList.push(TicketEntryHistory.JsonToTicket(ticket));
        }
    });
    return ticketEntryHistoryList.getEnteredTimeConverted(withoutPattern);
};
TicketEntryHistory.JsonToTicket = (data) => new TicketEntryHistory(data);
//# sourceMappingURL=TicketEntryHistory.js.map